import { render, staticRenderFns } from "./AssinaturaEletronica.vue?vue&type=template&id=1dd679c3&"
import script from "./AssinaturaEletronica.vue?vue&type=script&lang=js&"
export * from "./AssinaturaEletronica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports